"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const react_1 = tslib_1.__importStar(require("react"));
const ui_1 = require("../../../ui");
const getPlaceholderItems_1 = require("../utils/getPlaceholderItems");
exports.useOsmosysPaginatedItems = ({ showPlaceholders = true, placeholderCount, pathToItems, pathToCount, data, activePage = 0, pageSize, onPageChange, }) => {
    return react_1.useMemo(() => {
        // 1. Get Loaded Items or Placeholders
        const loadedItems = showPlaceholders
            ? getPlaceholderItems_1.getPlaceholderItems(placeholderCount)
            : typeof pathToItems === 'function'
                ? pathToItems(data)
                : lodash_1.get(data, pathToItems, getPlaceholderItems_1.getPlaceholderItems(placeholderCount));
        // 2. Get Server Side Count
        let serverSideCount = showPlaceholders
            ? placeholderCount
            : typeof pathToCount === 'function'
                ? pathToCount(data)
                : pathToCount
                    ? lodash_1.get(data, pathToCount, 0)
                    : 0;
        if (typeof serverSideCount !== 'number') {
            serverSideCount = 0;
        }
        // 3. Get Number of Pages
        const numberOfPages = serverSideCount
            ? Math.ceil(serverSideCount / pageSize)
            : 0;
        // 4. Render the pagination
        const pagination = serverSideCount && numberOfPages > 1 ? (react_1.default.createElement(ui_1.OsmosysPagination, { center: true, pageCount: numberOfPages, onPageChange: onPageChange, forcePage: activePage })) : null;
        return { loadedItems, numberOfPages, pagination, serverSideCount };
    }, [
        showPlaceholders,
        placeholderCount,
        pathToItems,
        pathToCount,
        data,
        activePage,
        pageSize,
        onPageChange,
    ]);
};
//# sourceMappingURL=useOsmosysPaginatedItems.js.map